import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import StopoverDuration from "app/pages/Stopover/StopoverDurations/StopoverDuration";
import "./StopoverDurations.scss";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import { useCallback } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const StopoverDurations = ({
	stopoverDurations = [],
	updateBooking = () => {},
	onChange = () => {},
}) => {
	const { track } = useAnalytics();

	const handleDurationSelection = useCallback(duration => {
		updateBooking({
			stopoverDuration: Number(duration),
		});

		track("stopover_duration_selected", {
			duration: Number(duration),
		});

		onChange(Number(duration));
	}, []);

	const warningMessageId =
		stopoverDurations.length === 1
			? "stop.over.durations.side.panel.one.duration.warning"
			: "stop.over.durations.side.panel.durations.warning";

	return (
		<div className="stopover-durations">
			<Typography variant={TYPOGRAPHY_VARIANTS.XL} component="h2" isBold>
				<FormattedMessage id="stop.over.durations.side.panel.durations.title" />
			</Typography>

			<div className="stopover-durations__warning">
				<AlertMessage
					message={
						<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>
							<FormattedMessage id={warningMessageId} />
						</Typography>
					}
				/>
			</div>

			<div className="stopover-durations__list">
				{stopoverDurations.map((stopoverDuration, index) => {
					return (
						<div key={index} className="stopover-durations__item">
							<StopoverDuration
								duration={stopoverDuration}
								onDurationSelect={handleDurationSelection}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

StopoverDurations.propTypes = {
	stopoverDurations: PropTypes.array,
	updateBooking: PropTypes.func,
	onChange: PropTypes.func,
};

export default StopoverDurations;
